import _ from 'underscore';

// A function that returns true if the given object is a promise.
export const isPromise = obj => _.isObject(obj) && _.isFunction(obj.then) && _.isFunction(obj.catch);
